import Functions from "../js/functions";
import $ from "jquery";

export default {
  init() {
      window.addEventListener("DOMContentLoaded", function () {
          Functions.maskInput();
      });

      let utm = {
          utm_source: Functions.getParameterByName('utm_source'),
          utm_medium: Functions.getParameterByName('utm_medium'),
          utm_channel: Functions.getParameterByName('utm_channel'),
          utm_keyword: Functions.getParameterByName('utm_keyword'),
          utm_content: Functions.getParameterByName('utm_content'),
          utm_campaign: Functions.getParameterByName('utm_campaign')
      };
      Object.keys(utm).forEach((key) => (utm[key] == null) && delete utm[key]);

      let $utm = $('<input>').attr({
          type: 'hidden',
          name: 'utm',
      }).appendTo($('form'));
      $utm.val(JSON.stringify(utm));
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

      let $submit;
      let submitText;

      jQuery(document).ajaxStart(function () {
          if (jQuery('.ajax-loader.is-active').length >= 1) {
              let $form = jQuery('.ajax-loader.is-active').closest('form');
              $submit = $form.find('input[type="submit"]');
              submitText = $submit.val();

              if (Functions.getParameterByName('lang') === 'ar') {
                  $submit.val('إرسال...');
              } else {
                  $submit.val('Sending...');
              }

              let $submits = jQuery('input[type="submit"]');
              $submits.attr('disabled', true);
              $submits.css('opacity', '0.7');
              $submits.css('cursor', 'progress');
          }
      });

      jQuery(document).ajaxComplete(function () {
          $submit.val(submitText);
          let $submits = jQuery('input[type="submit"]');
          $submits.attr('disabled', false);
          $submits.css('opacity', '1');
          $submits.css('cursor', 'pointer');
          jQuery('.ajax-loader.is-active').removeClass('is-active');
      });
  },
};
